"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const device_1 = require("@completeanatomy/device");
const ui_1 = require("@completeanatomy/ui");
function OfflineIndicator({ className }) {
    const isOffline = (0, device_1.useIsDeviceOffline)();
    if (isOffline) {
        return ((0, jsx_runtime_1.jsx)(Container, { className: className, "data-e2e": 'OfflineIndicator_Container', children: (0, jsx_runtime_1.jsx)(OfflineIcon, { name: ui_1.Icons.Offline, "data-e2e": 'OfflineIndicator_OfflineIcon' }) }));
    }
    else {
        return null;
    }
}
exports.default = OfflineIndicator;
const Container = styled_components_1.default.div `
  width: 20px;
  height: 20px;

  color: ${props => props.theme.settings.text};

  background-color: ${props => props.theme.primary};

  border-radius: 50%;
`;
const OfflineIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 100%;
  height: 100%;
`;
